var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.514 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z",
  stroke: "#231F20",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  fill: "#231F20"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 12h-2M3.5 12h-2M12 1.5v2M12 20.5v2",
  stroke: "#231F20",
  strokeWidth: 1.5
})));
export default SvgLocation;